'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isFuture;


// WEBPACK FOOTER //
// ./~/sugar-date/date/isFuture.js